import { render, staticRenderFns } from "./ViewTemplateMailComponent.vue?vue&type=template&id=19012b48&"
import script from "./ViewTemplateMailComponent.vue?vue&type=script&lang=js&"
export * from "./ViewTemplateMailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports